﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class ProfileClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiProfilesGet();
    }
    get(appIdProfile) {
        return this.client.apiProfilesByIdGet(appIdProfile);
    }
    getEditable() {
        return this.client.apiProfilesEditableGet();
    }
    create(profile) {
        return this.client.apiProfilesPost(profile);
    }
    update(existingProfileAppId, profile) {
        return this.client.apiProfilesByIdPut(existingProfileAppId, profile);
    }
    delete(data) {
        return this.client.apiProfilesDelete(data);
    }
}
exports.ProfileClient = ProfileClient;
//# sourceMappingURL=ProfileClient.js.map